import styled, { createGlobalStyle, DefaultTheme } from 'styled-components';
import { addPxSuffix } from '../helpers';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    overflow-x: hidden;

  .hidden-mobile {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.l}) {
    .hidden-mobile {
      display: block;
    }
    
    .hidden-desktop {
      display: none;
    }
  }

  .wg-drop.country-selector .wgcurrent a {
    font-family: 'Gotham', sans-serif !important;
    font-weight: 325 !important;
  }

    /* #onetrust-consent-sdk {
      font-family: 'Gotham', sans-serif !important;

      button {
        font-family: 'Gotham', sans-serif !important;
        font-weight: 325 !important;
      }

      a {
        color: ${({ theme }) => theme.colors.orangePeel} !important;
      }
    }

    .ot-always-active {
      color: ${({ theme }) => theme.colors.orangePeel} !important;
    }
    
    #onetrust-banner-sdk {
     bottom: 10% !important;
     top: unset !important;
    }

    #onetrust-policy-text {
      font-family: 'Gotham', sans-serif !important;
      font-weight: 325 !important;
    }

    #onetrust-reject-all-handler,
    #onetrust-accept-btn-handler,
    #onetrust-pc-btn-handler {
      font-family: 'Gotham', sans-serif !important;
      font-weight: 325 !important;
      border-radius: 6px;
      font-size: 13px !important;
    }

    #onetrust-pc-title {
      font-family: 'Gotham', sans-serif !important;
      font-weight: 325 !important;
    }

    #ot-pc-desc {
      font-family: 'Gotham', sans-serif !important;
      font-weight: 325 !important;
    }

    .ot-acc-grpdesc {
      font-family: 'Gotham', sans-serif;
      font-weight: 325 !important;
    } */
  
  .yarl__container {
    background-color: rgba(0, 0, 0, 0.80); /* Set custom opacity and color */
  }

  .yarl__navigation_prev, .yarl__navigation_next {
    filter: none;
    
    svg {
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: 50%;
      box-shadow: 0;

      path {
        &:last-of-type {
          fill: ${({ theme }) => theme.colors.black};
          transform: scale(0.7); /* Adjust as needed (0.8 = 80% of original size) */
          transform-origin: center;
        }
      }
 
    }
  }

  .yarl__navigation_prev {
    left: 5px;
  }

  .yarl__navigation_next {
    right: 5px;
  }

}

`;

export const MainSection = styled.section<{
  $color?: keyof DefaultTheme['colors'];
  $backgroundImage?: string;
  $mobileImage?: string;
  $overlay?: boolean;
  $overlayOpacity?: number;
  $noMargin?: boolean;
  $fullscreen?: boolean;
  $productPage?: boolean;
  $preOwned?: boolean;
  $center?: boolean;
  $overflow?: string;
  $minHeight?: string;
  $desktopMinHeight?: string;
  $aspectRatio?: string;
}>`
  width: 100%;
  margin: ${({ $noMargin, $productPage, $preOwned }) =>
    $noMargin || $productPage || $preOwned ? '0' : '76px 0'};
  min-height: ${({ $fullscreen, $minHeight }) =>
    $fullscreen ? 'calc(100vh + 1px)' : $minHeight || 'auto'};
  background: ${({ theme, $color }) => theme.colors[$color || 'none']};
  background-image: ${({ $backgroundImage, $mobileImage }) =>
    $mobileImage
      ? `url(${$mobileImage})`
      : $backgroundImage && `url(${$backgroundImage})`};
  position: relative;
  background-size: cover;
  background-position: center;
  padding-top: ${({ $productPage }) => ($productPage ? '180px' : '0')};
  overflow: ${({ $overflow }) => $overflow || 'visible'};
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || 'none'};

  ${({ $center }) =>
    $center &&
    `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `}

  ${({ $overlay }) =>
    $overlay &&
    `
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: ${
      $overlay
        ? `linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.34) 0%,
        rgba(0, 0, 0, 0.34) 100%
      )`
        : 'none'
    };
  }
`}

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    margin: ${({ $noMargin, $productPage, $preOwned }) =>
      $noMargin || $productPage || $preOwned ? '0' : '100px 0'};
    aspect-ratio: unset;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-top: ${({ $productPage, $preOwned }) =>
      $productPage ? '140px' : $preOwned ? '50px' : '0'};
    background-image: ${({ $backgroundImage }) =>
      $backgroundImage && `url(${$backgroundImage})`};
    min-height: ${({ $fullscreen, $desktopMinHeight }) =>
      $fullscreen ? 'calc(100vh + 1px)' : $desktopMinHeight || 'auto'};
  }
`;

export interface FlexProps {
  $flex?: number;
  $column?: boolean;
  $center?: boolean;
  $gap?: number;
  $dir?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  $align?: keyof DefaultTheme['align'];
  $justify?: keyof DefaultTheme['justify'];
  $wrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  $desktopDir?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  $desktopAlign?: keyof DefaultTheme['align'];
  $desktopJustify?: keyof DefaultTheme['justify'];
  $desktopGap?: number;
  $width?: string | number;
  $height?: string | number;
  $margin?: string | number;
  $marginDesktop?: string | number;
  $maxWidth?: string | number;
  $desktopWidth?: string | number;
  $breakpoint?: keyof DefaultTheme['breakpoints'];
  $padding?: string | number;
}

export const Flex = styled.div<FlexProps>`
  display: flex;
  position: relative;
  height: ${({ $height }) => addPxSuffix($height || 'auto')};
  width: ${({ $width }) => addPxSuffix($width || 'auto')};
  max-width: ${({ $maxWidth }) => addPxSuffix($maxWidth || '100%')};
  flex-wrap: ${({ $wrap }) => $wrap || 'nowrap'};
  flex-direction: ${({ $column, $dir }) =>
    $column ? 'column' : $dir || 'row'};
  align-items: ${({ $center, $align, theme }) =>
    $center ? 'center' : $align ? theme.align[$align] : 'flex-start'};
  justify-content: ${({ $center, $justify, theme }) =>
    $center ? 'center' : $justify ? theme.justify[$justify] : 'flex-start'};
  gap: ${({ $gap }) => ($gap ? $gap + 'px' : '0')};
  margin: ${({ $margin }) => addPxSuffix($margin || '0')};
  padding: ${({ $padding }) => addPxSuffix($padding || '0')};

  @media screen and (min-width: ${({ theme, $breakpoint }) =>
      theme.breakpoints[$breakpoint || 'l']}) {
    flex-direction: ${({ $desktopDir, $column, $dir }) =>
      $desktopDir ? $desktopDir : $column ? 'column' : $dir || 'row'};
    align-items: ${({ $desktopAlign, theme, $align, $center }) =>
      $desktopAlign
        ? theme.align[$desktopAlign]
        : $align
          ? theme.align[$align]
          : $center
            ? theme.align.center
            : 'flex-start'};
    justify-content: ${({ $desktopJustify, theme, $justify, $center }) =>
      $desktopJustify
        ? theme.justify[$desktopJustify]
        : $justify
          ? theme.justify[$justify]
          : $center
            ? theme.align.center
            : 'flex-start'};
    gap: ${({ $desktopGap, $gap }) =>
      $desktopGap ? $desktopGap + 'px' : $gap ? $gap + 'px' : '0'};
    margin: ${({ $marginDesktop, $margin }) =>
      addPxSuffix($marginDesktop || $margin || '0')};
    width: ${({ $width, $desktopWidth }) =>
      addPxSuffix($desktopWidth || $width || 'auto')};
    max-width: ${({ $desktopWidth, $width }) =>
      addPxSuffix($desktopWidth || $width || 'auto')};
  }
`;

export interface MainInnerProps extends FlexProps {
  $vericalPadding?: boolean;
  $desktopHeight?: string | number;
  $productPage?: boolean;
}

export const MainInner = styled(Flex)<MainInnerProps>`
  z-index: 1;
  display: flex;
  position: relative;
  height: ${({ $height }) => addPxSuffix($height || '100%')};
  width: ${({ $width }) => addPxSuffix($width || '100%')};
  flex-wrap: ${({ $wrap }) => $wrap || 'nowrap'};
  flex-direction: ${({ $column, $dir }) =>
    $column ? 'column' : $dir || 'column'};
  align-items: ${({ $center, $align, theme }) =>
    $center ? 'center' : $align ? theme.align[$align] : 'flex-start'};
  justify-content: ${({ $center, $justify, theme }) =>
    $center ? 'center' : $justify ? theme.justify[$justify] : 'flex-start'};
  gap: ${({ $gap }) => ($gap ? $gap + 'px' : '0')};
  margin: ${({ $margin }) => addPxSuffix($margin || '0 auto')};
  padding: ${({ $vericalPadding, $productPage }) =>
    $vericalPadding ? '76px 16px' : $productPage ? '0' : '0 16px'};

  @media screen and (min-width: ${({ theme, $breakpoint }) =>
      theme.breakpoints[$breakpoint || 'l']}) {
    max-width: 1760px;
    flex-direction: ${({ $desktopDir, $column, dir }) =>
      $desktopDir ? $desktopDir : $column ? 'column' : dir || 'column'};
    align-items: ${({ $desktopAlign, theme, $align, $center }) =>
      $desktopAlign
        ? theme.align[$desktopAlign]
        : $align
          ? theme.align[$align]
          : $center
            ? theme.align.center
            : 'flex-start'};
    justify-content: ${({ $desktopJustify, theme, $justify, $center }) =>
      $desktopJustify
        ? theme.justify[$desktopJustify]
        : $justify
          ? theme.justify[$justify]
          : $center
            ? theme.align.center
            : 'flex-start'};
    gap: ${({ $desktopGap, $gap }) =>
      $desktopGap ? $desktopGap + 'px' : $gap ? $gap + 'px' : '0'};
    margin: ${({ $marginDesktop, $margin }) =>
      addPxSuffix($marginDesktop || $margin || '0 auto')};
    padding: ${({ $vericalPadding }) =>
      $vericalPadding ? '100px 61px' : '0 61px'};
    height: ${({ $desktopHeight }) => addPxSuffix($desktopHeight || '100%')};
  }
`;

export default GlobalStyle;
